<div id="panel-options" 
  data-role="panel" 
  data-display="overlay"
  data-position="right" 
  data-theme="a"
  data-overlay-theme="b">

  <h3><%= string('options') %></h3>

  <ul data-role="listview">
    <li data-role="list-divider"><%= string('share-to') %></li>
    <li>
      <a id="share-facebook" class="share-button" href="http://www.facebook.com/sharer/sharer.php?u=http://tiny.cc/champions" target="_blank">
        <img src="images/share/facebook_32.png" class="ui-li-icon ui-corner-none">
        <%= string('facebook') %>
      </a>
    </li>
    <li>
      <a id="share-twitter" class="share-button" href="https://twitter.com/share?url=http://tiny.cc/champions" target="_blank">
        <img src="images/share/twitter_32.png" class="ui-li-icon ui-corner-none">
        <%= string('twitter') %>
      </a>
    </li>
    <li>
      <a id="share-googleplus" class="share-button" href="https://plus.google.com/share?url=http://tiny.cc/champions" target="_blank">
        <img src="images/share/googleplus_32.png" class="ui-li-icon ui-corner-none">
        <%= string('google') %>+
      </a>
    </li>
    <li data-role="list-divider"><%= string('language') %></li>
    <% _(['en', 'es', 'ru']).each(function(lang){ %>
      <li>
        <a href="" class="change-lang" lang="<%= lang %>">
          <img src="images/lang/<%= lang %>.png" class="ui-li-icon ui-corner-none">
          <%= CoC.lang[lang].name %>
        </a>
      </li>
    <% }) %>
    <li data-role="list-divider"><%= string('tools') %></li>
    <% if(current !== 'app-roster'){ %>
      <li>
        <a href="/contest-of-champions/<%= search %>" target="_blank">
          <img src="images/icon.png" class="ui-li-icon ui-corner-none">
          <%= string('roster-manager') %>
        </a>
      </li>
    <% } %>
    <% if(current !== 'app-synergies'){ %>
      <li>
        <a href="/contest-of-champions/synergies.html<%= search %>" target="_blank">
          <img src="images/icon.png" class="ui-li-icon ui-corner-none">
          <%= string('synergy-map') %>
        </a>
      </li>
    <% } %>
  </ul>
</div>

<div id="popup-update"
     data-role="popup"
     data-display="overlay"
     data-position="window"
     data-theme="b"
     data-overlay-theme="b">
    <div class="ui-content">
        <h3>Deprecated</h3>
        <div>
            Please use the new version of the app at
            <a href="http://hook.github.io/champions">http://hook.github.io/champions</a>
        </div>
        <br />
        <div>
            <input id="checkbox-update" type="checkbox" />
            <label for="checkbox-update" style="display:inline-block;">
                Do not show again.
            </label>
        </div>
    </div>
</div>
